










/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import * as _ from 'lodash';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import AddUpdateSpace from './components/add-update-space.vue';
@Component({
  components: { AddUpdateSpace }
})
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  // 面板屑
  private navs: any = [
    {
      label: '车位资源管理',
      location: {
        name: routeNames.PARKING_SPACE_LIST
      }
    },
    { label: '车位新增' }
  ];
  isEdit: boolean = false;
}
